import { cloneDeep as _cloneDeep } from "lodash"
import { store } from '@/store/store'
import { AreaTypes, GeometryTypes } from "@/helpers/enums"
import ApiDataModel from "@/models/apidatamodel"
import MunicipalitiesAndRegionsModel from "@/models/municipalitiesandregionsmodel"

export default class AreaUtils {
    allowedGeometryTypes = [GeometryTypes.GeometryCollection, GeometryTypes.MultiPolygon, GeometryTypes.Polygon]

    /**
     * Palauttaa kuntien tai maakuntien rajat ja perustiedot
     * @param areaType Alueen tyyppi. Kunta/maakunta.
     * @param handleOnClick Käsitelläänkö aluee click eventit
     * @returns ApiDataModel array
     */
    public getAreas(areaType: AreaTypes, handleOnClick = true): Array<ApiDataModel> {
        const models = new Array<ApiDataModel>()

        // Haetaan ensin alueiden rajat storesta
        let areas: Array<MunicipalitiesAndRegionsModel> | undefined
        if (areaType === AreaTypes.Municipality) {
            areas = this.getMunicipalities()
        }
        else if (areaType === AreaTypes.Province) {
            areas = this.getRegions()
        }

        if (areas !== undefined) { // Koko maalle ei ole rajoja
            areas.forEach((value) => {
                if (value.koordinaatit) {
                    let id: string = "0"
                    if (areaType === AreaTypes.Municipality) {
                        id = value.kuntanumero ?? "0"
                    }
                    else if (areaType === AreaTypes.Province) {
                        id = value.maakuntanumero
                    }

                    if (id !== "0") {
                        const options = {
                            fillColor: "",
                            fillOpacity: 0,
                            color: "#6D6D6D",
                            opacity: 0.5,
                            weight: 1,
                            fill: true,
                            stroke: true,
                            id
                        }

                        value.koordinaatit.options = options
                        value.koordinaatit.handleOnClick = handleOnClick
                        value.koordinaatit.allowedGeometryTypes = this.allowedGeometryTypes

                        models.push(new ApiDataModel(id, true, value.koordinaatit, value, null, null))
                    }
                }
            })
        }

        return models
    }

    /**
     * Parsii AreaTypen datan sisällön perusteella
     */
    public getAreaTypeFromData(data): AreaTypes {
        if (data.length >= 1 && data[0].kuntanumero != null && data[0].kuntanumero !== "0") {
            return AreaTypes.Municipality
        }
        else if (data.length >= 1 && data[0].maakuntanumero != null && data[0].maakuntanumero !== "0") {
            return AreaTypes.Province
        }
        return AreaTypes.Country
    }

    /**
     * Parsii AreaTypen tekstin perusteella
     */
    public getAreaTypeFromText(text: string): AreaTypes {
        if (text === "kunta") {
            return AreaTypes.Municipality
        }
        if (text === "maakunta") {
            return AreaTypes.Province
        }
        return AreaTypes.Country
    }

    /**
     * Hakee kunnat storesta. Tehdään "syväklooni", koska geometrioita muunnetaan ennen piirtoa.
     * Kun kunnat haetaan uudestaan storesta niin geometriat muunnetaan uudestaan ja jos ei tehdä kunnon kloonia niin muunnetut arvot päivittyä storeen
     */
    public getMunicipalities(): Array<MunicipalitiesAndRegionsModel> {
       return _cloneDeep(store.getters.municipalitiesData)
    }

    /**
     * Hakee maakunnat storesta. Tehdään "syväklooni", koska geometrioita muunnetaan ennen piirtoa.
     * Kun maakunnat haetaan uudestaan storesta niin geometriat muunnetaan uudestaan ja jos ei tehdä kunnon kloonia niin muunnetut arvot päivittyä storeen
     */
    public getRegions(): Array<MunicipalitiesAndRegionsModel> {
       return _cloneDeep(store.getters.regionsData)
    }
}
